module.exports = __webpack_public_path__ + "img/password-icon.5cc5f77b.svg";